package components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import styles.AppStyleSheet

/**
 * Notification permission prompt modal component
 * Shows a custom modal to request push notification permission on first visit
 */
@Composable
fun NotificationPermissionPrompt(
    isVisible: Boolean,
    onEnable: () -> Unit,
    onLater: () -> Unit,
) {
    if (!isVisible) return

    Div({ classes(AppStyleSheet.modalOverlay) }) {
        Div({ classes(AppStyleSheet.modalContent) }) {
            H2({
                style {
                    fontSize(24.px)
                    marginBottom(16.px)
                    textAlign("center")
                }
            }) {
                Text("通知を受け取りますか？")
            }

            Div({
                style {
                    fontSize(48.px)
                    textAlign("center")
                    marginBottom(16.px)
                }
            }) {
                Text("🔔")
            }

            P({
                style {
                    fontSize(14.px)
                    color(Color("#666"))
                    marginBottom(24.px)
                    lineHeight("1.5")
                }
            }) {
                Text("プッシュ通知を有効にすると、新しい投稿やコメントに関する通知を受け取ることができます。")
            }

            Div({
                style {
                    display(DisplayStyle.Flex)
                    gap(12.px)
                    justifyContent(JustifyContent.Center)
                }
            }) {
                Button({
                    classes(AppStyleSheet.primaryButton)
                    onClick { onEnable() }
                    style {
                        flex(1)
                    }
                }) {
                    Text("通知を受け取る")
                }

                Button({
                    classes(AppStyleSheet.secondaryButton)
                    onClick { onLater() }
                    style {
                        flex(1)
                    }
                }) {
                    Text("後で")
                }
            }
        }
    }
}
